import { NgModule } from '@angular/core';
 
import { CommonModule } from '@angular/common';

import { ConfirmDialogRoutingModule } from './confirm-dialog-routing.module';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationComponent } from '@app/features-modules/client/appoinment-form/confirmation/confirmation.component';
import { ConfirmationCalendarSyncComponent } from '@shared/confirmation-calendar-sync/confirmation-calendar-sync.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ConfirmDialogRoutingModule,
    MatIconModule,
    TranslateModule,
    FormsModule
  ],  
  exports: [  
      ConfirmDialogComponent,
      ConfirmationCalendarSyncComponent
  ],
  declarations: [ConfirmDialogComponent,
    ConfirmationCalendarSyncComponent],
  entryComponents: [],
  providers: [  
    ConfirmDialogService  
 ] 
})
export class ConfirmDialogModule { }
